<script setup>
import { computed } from 'vue'
import { getTeamMemberInitial, resolveTeamMember } from '@/Utils/teamAccessSummary'

const props = defineProps({
	params: {
		type: Object,
		default: null,
	},
	member: {
		type: Object,
		default: null,
	},
	// Dim the identity (avatar + name + email + role badge) for paused members.
	// Dimming is applied here (and on access) rather than in every child cell so
	// a paused row dims once; the status word + kebab stay full opacity so the
	// "Enable" action stays discoverable. The #meta slot is intentionally left
	// OUTSIDE the dimmed block for that reason.
	dim: {
		type: Boolean,
		default: false,
	},
	// The `#badge` slot renders inline after the name (mobile card). The desktop
	// table sets this false and renders the role in its own aligned ROLE column
	// instead, so badges don't zig-zag after variable-length names.
	inlineRole: {
		type: Boolean,
		default: true,
	},
})

const data = computed(() => resolveTeamMember(props))
const initial = computed(() => getTeamMemberInitial(data.value))
</script>

<template>
	<div class="flex items-center gap-3 min-w-0 w-full h-full">
		<span
			class="grid size-9 shrink-0 place-items-center rounded-md bg-surface-3 text-surface-9 text-sm font-semibold uppercase"
			:class="dim ? 'opacity-60' : ''"
		>
			{{ initial }}
		</span>
		<div class="min-w-0 flex-1">
			<div :class="dim ? 'opacity-60' : ''">
				<div class="flex items-center gap-2 min-w-0">
					<p class="min-w-0 text-sm font-medium text-surface-9 leading-5 truncate mb-0" :title="data.name">{{ data.name }}</p>
					<slot v-if="inlineRole" name="badge" />
				</div>
				<p class="text-sm text-surface-7 leading-5 truncate mb-0" :title="data.email">{{ data.email }}</p>
			</div>
			<slot name="meta" />
		</div>
	</div>
</template>
